import React, { useState, useEffect } from "react";
import { DateRangePicker } from "react-dates";
import "moment/locale/pt-br";

import { Container, FilterTitle, FilterInputCalenderContainer } from "./styles";

//Assets
import calendarIcon from "../../assets/icons/calendar.svg";
import dateArrow from "../../assets/icons/date-arrow.svg";

const RangeDatePicker = (props) => {
    // const [startDate, setStartDate] = useState(null);
    // const [endDate, setEndDate] = useState(null);
    const [focusedInput, setFocusedInput] = useState(null);
    const [screenWidth, setScreenWidth] = useState(null);

    useEffect(() => {
        setScreenWidth(window.screen.width);
    }, []);

    const handleChangeDate = (startDateParam, endDateParam) => {
        props.setStartDate(startDateParam);
        props.setEndDate(endDateParam);
    }

    return (
        <Container>
            <FilterInputCalenderContainer>
                <img src={calendarIcon} alt="Calendário"/>
                <DateRangePicker
                    startDate={props.startDate} // momentPropTypes.momentObj or null,
                    startDateId="startDate" // PropTypes.string.isRequired,
                    startDatePlaceholderText= "dd/mm/aaaa"
                    endDate={props.endDate} // momentPropTypes.momentObj or null,
                    endDateId="endDate" // PropTypes.string.isRequired,
                    endDatePlaceholderText="dd/mm/aaaa"
                    customArrowIcon={<img src={dateArrow} alt="Seta para direita"/>}
                    onDatesChange={({ startDate, endDate }) => {
                        handleChangeDate(startDate, endDate)
                    }} // PropTypes.func.isRequired,
                    focusedInput={focusedInput} // PropTypes.oneOf([START_DATE, END_DATE]) or null,
                    onFocusChange={focusedInput => setFocusedInput(focusedInput)} // PropTypes.func.isRequired,
                    isOutsideRange={() => false}
                    displayFormat="DD/MM/YY"
                    readOnly
                    numberOfMonths={screenWidth <= 500 ? 1 : 2}
                    disabled={!props.isDisabled}
                />
            </FilterInputCalenderContainer>
        </Container>
    )
}

export default RangeDatePicker;